import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    makeStyles
} from '@material-ui/core'

const useStyles = makeStyles({
    title: {
        borderBottom: '1px solid #dee2e6'
    },
    content: {
        padding: '20px 24px',
        minWidth: 380
    },
    cancelButton: {
        color: '#ef8c25'
    }
})

/**
 * Imperative confirmation dialog. Hold a ref and call
 * ref.current.confirm({ title, message, confirmLabel, destructive, onConfirm }).
 */
function ConfirmActionDialog(props, ref) {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false)
    const [busy, setBusy] = React.useState(false)
    const [config, setConfig] = React.useState({})

    const close = React.useCallback(() => {
        if (busy) return
        setOpen(false)
    }, [busy])

    React.useImperativeHandle(ref, () => ({
        confirm: options => {
            setConfig(options || {})
            setOpen(true)
        }
    }))

    const onConfirm = React.useCallback(async () => {
        if (!config.onConfirm) {
            setOpen(false)
            return
        }
        try {
            setBusy(true)
            await config.onConfirm()
            setOpen(false)
        } finally {
            setBusy(false)
        }
    }, [config])

    return (
        <Dialog open={open} onClose={close}>
            <DialogTitle className={classes.title}>
                <Typography variant="subtitle1">{config.title || 'Are you sure?'}</Typography>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <DialogContentText component="div">
                    {config.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={close} disabled={busy} className={classes.cancelButton}>
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color={config.destructive ? 'secondary' : 'primary'}
                    disabled={busy}
                >
                    {busy ? 'Working…' : (config.confirmLabel || 'Confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default React.forwardRef(ConfirmActionDialog)
